/**
 * Responsible for storing data locally.
 */
class LocalData
{


    constructor()
    {
        this.app = PIXI.app;
    }


    /**
     * Save a value under a specific identifier.
     * @public
     * @param name
     * @param value
     */
    saveValue(name, value)
    {
        try
        {
            localStorage.setItem(name, value);
        }
        catch(e)
        {
            console.log("Cannot save to local storage.")
        }
    }


    /**
     * Retrieve a value under a specific identifier.
     * @public
     * @param name
     * @param value
     */
    getValue(name)
    {
        return localStorage.getItem(name);
    }


    /**
     * Retrieve a value and cast it to a Number
     * @param name
     * @returns {number}
     */
    getNumber(name)
    {
        let val = this.getValue(name);
        let num = NaN;

        if (val != null)
        {
            num = Number(val);
        }

        return num;
    }


    /**
     * Get a boolean value with specific identifier. If such identifier has not been previously used
     * it is saved with the specified init state.
     * @public
     * @param name
     * @param initState
     * @returns {Boolean}
     */
    getBooleanValue(name, initState=true)
    {
        let b = this.getValue(name);

        if (b == null)
        {
            this.saveValue(name, initState);
            return initState;
        }
        else
        {
            b = b == "true";
        }

        return b;
    }


}


export default LocalData;